import { FC } from "react";

import { FullWidthVStack } from "@components/common";

import { DeliveryMethod, OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";
import ReceiverAddressFormFields from "../common/ReceiverAddressFormFields";
import ReceiverLockerFormFields from "../common/ReceiverLockerFormFields";

const ReceiverFormFields: FC = () => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  return (
    <FullWidthVStack spacing="1rem">
      {deliveryMethod === DeliveryMethod.DoorToDoor && <ReceiverAddressFormFields />}
      {deliveryMethod === DeliveryMethod.DoorToPudo && <ReceiverLockerFormFields />}
    </FullWidthVStack>
  );
};
export default ReceiverFormFields;
